export default {
    /**
     * Returns random password string
     * @param {number} length - Number of password characters.
     * @param {boolean} specialChars - Optional, decision if special chars '!@#$%^&*()-+<>' should be included in password.
     * @returns {string} string
     */
    _randomPassword(length: number, specialChars: boolean = true) {
        const chars = specialChars ? 'abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890' : 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890';
        let pass = '';
        for (let passwordIndex = 0; passwordIndex < length; passwordIndex++) {
            const index = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(index);
        }
        return pass;
    }
};
